"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Importance = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var Importance = /*#__PURE__*/function () {
  function Importance() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    (0, _classCallCheck2.default)(this, Importance);
    (0, _defineProperty2.default)(this, "value", 0);
    this.set(value);
  }

  (0, _createClass2.default)(Importance, [{
    key: "get",
    value: function get() {
      return this.value;
    }
  }, {
    key: "set",
    value: function set(value) {
      if (value === undefined) {
        this.value = 0;
      } else if (value >= 0 && value <= 5) {
        this.value = Math.round(value);
      } else {
        this.value = 0;
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      if (!this.value) {
        return Importance.importanceMapping[0];
      }

      var importanceValue = Math.round(this.value);

      if (importanceValue < 0) {
        importanceValue = 0;
      } else if (importanceValue > 5) {
        importanceValue = 5;
      }

      var importanceString;

      if (importanceValue) {
        importanceString = Importance.importanceMapping[importanceValue];
      } else {
        importanceString = Importance.importanceMapping[0];
      }

      return importanceString || Importance.importanceMapping[0];
    }
  }]);
  return Importance;
}();

exports.Importance = Importance;
(0, _defineProperty2.default)(Importance, "importanceMapping", {
  0: 'Not sure.',
  1: 'Not important to me.',
  2: 'A little important to me.',
  3: 'Fairly important to me.',
  4: 'Very important to me.',
  5: 'It is my life\'s purpose.'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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